import { render } from "./indexfiveservice.vue?vue&type=template&id=7dd2c61f"
import script from "./indexfiveservice.vue?vue&type=script&lang=js"
export * from "./indexfiveservice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__